import { connect } from 'react-redux'
import NavButton from '../../components/navButton/navButtonComponent'
import { State } from '../../redux/reducers/'
import { actionCreators } from '../../redux/reducers/login/loginReducer'

export function mapStateToProps (state: State, props): Values {
  return { display: !state.login.authorized }
}
export const propsMapping: Callbacks = {
  onClick: actionCreators.showLogin
}

export default connect(mapStateToProps, propsMapping)(NavButton)



// WEBPACK FOOTER //
// ./src/containers/showLoginButton/showLoginButtonContainer.js